import useAuth from '@app/auth/use-auth';
import { useItemScope } from '@app/purchased-goods/components/item-detail/use-item-scope';
import { Tab } from '@shared/components/page-tabs';
import { Badge } from '@shared/components/ui/badge';
import { generatePath } from 'react-router-dom';
import { purchasedGoodsRoutes } from '../purchased-goods-routes';
import { usePurchasedPackagingItem } from './purchased-packaging-item-context';

export function usePurchasedPackagingTabs(): Tab[] {
  return [
    {
      title: 'Items',
      href: purchasedGoodsRoutes.PURCHASED_PACKAGING,
    },
    {
      title: 'Data coverage',
      href: purchasedGoodsRoutes.PURCHASED_PACKAGING_DATA_COVERAGE,
    },
  ];
}

export function usePurchasedPackagingItemsTabs(): Tab[] {
  const { item } = usePurchasedPackagingItem();
  const { user } = useAuth();
  const { scopeSearch } = useItemScope();

  const params = { item_uuid: item?.uuid || ':item_uuid' };

  const tabs: Tab[] = [
    {
      title: 'Overview',
      href:
        generatePath(purchasedGoodsRoutes.PURCHASED_PACKAGING_ITEM, params) +
        scopeSearch,
    },
    {
      title: 'Modelling',
      href:
        generatePath(
          purchasedGoodsRoutes.PURCHASED_PACKAGING_ITEM_MODELLING,
          params
        ) + scopeSearch,
    },
    {
      title: 'Purchases',
      href:
        generatePath(
          purchasedGoodsRoutes.PURCHASED_PACKAGING_ITEM_PURCHASES,
          params
        ) + scopeSearch,
    },
  ];

  if (user?.features.cost) {
    tabs.push({
      title: 'Spend',
      href:
        generatePath(
          purchasedGoodsRoutes.PURCHASED_PACKAGING_ITEM_SPEND,
          params
        ) + scopeSearch,
      icon: (
        <Badge variant="new_feature" size="sm">
          new
        </Badge>
      ),
    });
  }

  return tabs;
}
